export interface IColumn {
  Header: string;
  accessor: string;
  width: number;
}

const columns = [
  {
    Header: 'Beneficiary Name',
    accessor: 'beneficiaryName',
    width: 150,
  },
  {
    Header: 'Beneficiary Account',
    accessor: 'beneficiaryAccount',
    width: 100,
  },
  {
    Header: 'Beneficiary Bank',
    accessor: 'beneficiaryBank',
    width: 120,
  },
  {
    Header: 'Bank Branch',
    accessor: 'bankBranch',
    width: 120,
  },
  {
    Header: 'Amount',
    accessor: 'transactionAmount',
    width: 120,
  },
  {
    Header: 'Transaction Type',
    accessor: 'transactionType',
    width: 120,
  },
  {
    Header: 'Description',
    accessor: 'transactionNarration',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'description',
    width: 260,
  },
];

export default columns;
